<template>
    <vx-card title="Коэффициенты площадок и тематик" id="loader">
        <div class="vx-row mt-1">
            <div class="vx-col w-1/5">
                <label class="vs-input--label">
                    Тематика
                </label>
                <v-select
                    :options="dicts.adTags"
                    label="name"
                    placeholder="Выберите тематику"
                    class="w-full"
                    v-model="form.adTag">
                </v-select>
            </div>
            <div class="vx-col w-1/5">
                <label class="vs-input--label">
                    Площадка
                </label>
                <vs-input 
                      v-model="form.siteId" 
                      autocomplete="off" 
                      placeholder="Введите площадку" 
                      class="w-full"/>
                </div>
        </div>

        <div class="vx-row mt-1 mb-3">
            <div class="vx-col">
                <vs-button class="mt-1" color="warning" @click="loadCoeffs()" type="filled">
                    Применить
                </vs-button>
            </div>
        </div>

        <vs-table stripe :data="items" max-items="10" :sst="true" @sort="handleSort" class="mt-1">
            <template slot="header">
            </template>
            <template slot="thead">
                <vs-th sort-key="attr">
                    Площадка
                </vs-th>
                <vs-th sort-key="sspId">
                    Тематика
                </vs-th>
                <vs-th sort-key="sspId">
                    Сумм. расход <br />по кликам
                </vs-th>
                <vs-th sort-key="sspId">
                    Сумм. расход <br />по показам (с коэфом)
                </vs-th>
                <vs-th sort-key="sspId">
                    Сумм. расход <br />по показам (без коэфа)
                </vs-th>
                <vs-th sort-key="sspId">
                    Ошибка, %
                </vs-th>
                <vs-th sort-key="coeff">
                    Коэффициент
                </vs-th>
                <vs-th sort-key="coeff">
                    Дата
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{tr.siteId}}</vs-td>
                    <vs-td>[{{tr.adTagId}}] {{tr.adTagName}}</vs-td>
                    <vs-td>{{tr.clickSum}}</vs-td>
                    <vs-td>{{tr.buyoutSum}}</vs-td>
                    <vs-td>{{tr.finalCpmSum}}</vs-td>
                    <vs-td>{{tr.errorPercent}}</vs-td>
                    <vs-td>{{tr.coeff}}</vs-td>
                    <vs-td>{{tr.createdAt | moment('DD.MM.YYYY HH:mm')}}</vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>
    </vx-card>
</template>


<script>
    import axios from 'axios';
    import vSelect from 'vue-select';

    export default {
        name: 'site-adtag-coefficients',
        data() {
            return {
                items: [],
                page: 1,
                pageSize: 50,
                pagesTotal: 1,
                orderBy: undefined,
                isAscOrder: false,
                form: {
                    siteId: undefined,
                    adTag: undefined
                },
                dicts: {
                    adTags: []
                }
            }
        },
        methods: {
            loadDicts() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.axios.all([
                        this.axios.get('site-adtag-coeffs/dicts', { }),
                    ])
                    .then(axios.spread((dicts) => {
                        this.dicts.adTags = dicts.data.adTags;
                    }))
                    .catch((err) => {
                        this.$vs.notify({
                            title: "Ошибка!",
                            text: "Ошибка загрузки фильтров.",
                            color: "danger",
                        });
                    })
                    .finally(() => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                    });
            },
            loadCoeffs() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                var params = {
                    page: this.page,
                    size: this.pageSize,
                    orderBy: this.orderBy,
                    isAscOrder: this.isAscOrder,
                    siteId: this.form.siteId,
                    adTagId: this.form.adTag ? this.form.adTag.id : ''
                }

                this.axios
                    .all([
                        this.axios.get('site-adtag-coeffs', {
                            params: params
                        }),
                        this.axios.get('site-adtag-coeffs/count', {
                            params: params
                        })
                    ])
                    .then(
                        axios.spread((items, count) => {
                            this.items = items.data;
                            this.pagesTotal = Math.ceil(count.data / this.pageSize);
                        })
                    )
                    .catch((err) => {
                        this.$vs.notify({
                            title: 'Ошибка!',
                            text: 'Ошибка загрузки данных.',
                            color: 'danger'
                        });
                    })
                    .finally(() => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                    });
            },
            handleSort(key, active) {
                this.orderBy = key;

                if (active == 'asc')
                    this.isAscOrder = true;
                if (active == 'desc')
                    this.isAscOrder = false

                this.loadCoeffs();
            }
        },
        watch: {
            page: function () {
                this.loadCoeffs();
            }
        },
        mounted() {
            this.loadDicts();
            this.loadCoeffs();
        },
        components: {
            vSelect
        },
    }
</script>

<style lang="scss">
    table {
        tr.selected {
            cursor: text !important;
        }
    }
    thead {
        th {
            font-size: 15px !important;

            .sort-th {
                i {
                    font-size: 19px;
                }
            }
        }
    }
    .header-title {
        flex-direction: column;
    }
    .vs-pagination--mb {
        justify-content: center !important;
    }
</style>